import { hexToRgb } from '@aysar/contracts';

/**
 * `#RRGGBB` → the `H S% L%` channel triplet `globals.css` declares every colour
 * token in, so a runtime value slots into `hsl(var(--x) / <alpha-value>)`
 * exactly as the stylesheet's own do — alpha modifiers included.
 *
 * Rounded to whole units, like the stylesheet; hue is `0` for a grey.
 */
export function hexToHslChannels(hex: string): string {
  const { r, g, b } = hexToRgb(hex);
  const red = r / 255;
  const green = g / 255;
  const blue = b / 255;
  const max = Math.max(red, green, blue);
  const min = Math.min(red, green, blue);
  const delta = max - min;
  const lightness = (max + min) / 2;

  let hue = 0;
  let saturation = 0;

  if (delta !== 0) {
    saturation = delta / (1 - Math.abs(2 * lightness - 1));

    if (max === red) {
      hue = ((green - blue) / delta) % 6;
    } else if (max === green) {
      hue = (blue - red) / delta + 2;
    } else {
      hue = (red - green) / delta + 4;
    }

    hue *= 60;
    if (hue < 0) hue += 360;
  }

  return `${String(Math.round(hue))} ${String(Math.round(saturation * 100))}% ${String(Math.round(lightness * 100))}%`;
}
